<template lang="html">

	<section class="producto-home -caramelos column-center">

		<div class="container container-title animation">
			<!-- <h1 class="big-title animation" id="titulo-split" data-splitting="chars">{{$t('header.caramelos')}}</h1> -->
			<h2 class="big-title animation" id="titulo-split" >{{$t('header.caramelos')}}</h2>
		</div>

		<div class="contenedor-ruleta">

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.caramelosTradicionales')" :activo="select == 'caramelos'" @mouseover.native="select = 'caramelos'" class="boton" data="caramelos">
				<img :src="'/static/img/logos/logo-caramelos-tradicionales-'+$i18n.locale+'.png'" alt="logo-caramelos-tradicionales">
			</router-link>

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.azucares0')" :activo="select == '0-azucares'" @mouseover.native="select = '0-azucares'" class="boton" data="0-azucares">
				<img :src="'/static/img/sticker-sin-azucares-'+$i18n.locale+'.svg'" class="waypoints" alt="sticker-sin-azucares">
			</router-link>

			<div class="contenedor-texto">
				<espiral class="espiral-ani" delay="1000"></espiral>
				<p class="yummy waypoints">{{$t('sweetlover')}}</p>
			</div>



			<div class="contenedor-imagen row-center">

				<img alt="imagen producto inicial" v-show="select == 'inicial'" class="animated tada" :src="'/static/img/ruleta-home/caramelos/inicial.png'">
				<img alt="imagen producto caramelos" v-show="select == 'caramelos'" class="animated tada logo-caramelos" :src="'/static/img/ruleta-home/caramelos/caramelos.png'">
				<img alt="imagen producto 0-azucares" v-show="select == '0-azucares'" class="animated tada logo-0azucar" :src="'/static/img/ruleta-home/caramelos/0-azucares.png'">
				

			</div>

		</div>

		<div class="contenedor-boton">
			<espiral class="espiral-ani" delay="0"></espiral>
			<router-link :to="$t('enlaces.caramelos')" class="btn -action waypoints" v-html="$t('todosNuestrosCaramelos')"></router-link>
		</div>

		<img class="frutas-tradicionales" src="/static/img/decoracion-caramelos/frutas-tradicionales.png" alt="frutas-tradicionales">
		<img class="fruta-0-azucares" src="/static/img/decoracion-caramelos/fruta-0-azucares.png" alt="fruta-0-azucares">
		<img class="naranja" src="/static/img/decoracion-galletas/naranja.png" alt="naranja">



	</section>

</template>

<script lang="js">

	import espiral from '@/components/parts/icons/espiral'

	export default  {
		name: 'modulo-caramelos',
		data(){
			return{
				select : 'caramelos',
			}
		},
		components:{
			'espiral' : espiral
		}

	}
</script>

<style scoped lang="scss">
	.logo-caramelos {
		width: 215px;
	}
	.logo-0azucar{
		width: 275px;
	}
	.producto-home {
		background-image: linear-gradient(to bottom, #ff5649, #b90006);
	}
	
	.frutas-tradicionales{
		position: absolute;
		right: -100px;
		top: 100px;
	}
	.fruta-0-azucares{
		max-width: 300px;
		position: absolute;
		left: 20px;
		top: 20px;
	}
	.naranja{
		position: absolute;
		left: 50%;
		margin-left: -20px;
		bottom: -150px;
		max-width: 300px;
	}

	.boton{
		&[data=caramelos]{
			top: 50%;
			margin-top: -60px;
			right: 0;
		}
		&[data="0-azucares"]{
			left: 0;
			top: 50%;
			margin-top: -60px;
		}
	}


	h3{
		font-size: 33px;
		text-transform: uppercase;
		color: #fff;
		font-family: 'Futura LT CondensedExtraBold';
		line-height: 1.2em;
		transform: rotate(-9deg);
		strong{
			font-family: 'Futura LT CondensedExtraBold';
			font-size: 65px;
			line-height: 1em;
		}
	}

	.btn{
		font-size: 54px;
		color: #bd2826;
		max-width: fit-content;
		height: 80px;
		line-height: 70px;

		span{
			font-size: 16px;
			color: #bd2826;
		}
	}

	.gajo-naranja{
		position: absolute;
		top: 200px;
		max-width: 200px;
		right: -30px;
	}
	.gajo-limon{
		position: absolute;
		top: -40px;
		max-width: 200px;
		right: 50%;
		margin-right: -100px;
	}
	.acido-verde-amarillo{
		position: absolute;
		left: 100px;
		top: -120px;
		max-width: 300px;
	}

	.azul-individual{
		position: absolute;
		left: 100px;
		bottom: -20px;
		max-width: 230px;
	}

	.lima{
		position: absolute;
		bottom: -150px;
		right: -150px;
		max-width: 400px;
		filter: blur(2px);
	}

	.limon{
		position: absolute;
		bottom: 350px;
		left: 50px;
		max-width: 250px;
		filter: blur(1px);
	}

	.contenedor-texto{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 200px;
		height: 300px;
		padding-top: 200px;
		transform: rotate(10deg);

		.contenedor-espiral{
			position: absolute;
			left: 60px;
			top: 20px;
			transform: scale(.8) rotate(20deg);
		}

		p{
			font-size: 36px;
			color: white;
			display: inline-block;
			line-height: 30px;
			margin-top: 30px;
			animation-delay: 2s;
		}
	}


	@media screen and (max-width: 1500px){
		.frutas-tradicionales{
			max-width: 200px;
			right: -50px;
		}
	}

	@media screen and (max-width: 1220px){
		
		.fruta-0-azucares{
			max-width: 200px;
		}

	}

	@media screen and (max-width: 900px){
		.contenedor-texto{
			display: none;
		}
		.big-title{
			font-size: 90px;
		}

		.naranja{
			max-width: 200px;
			bottom: -50px;
			left: 20px;
		}
		.fruta-0-azucares{
			display: none;
		}
	}

	
	@media screen and (max-width: 560px){
		.big-title{
			font-size: 50px;
		}

		.naranja{
			bottom: -120px;
		}
	}


</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-caramelos.vue